











import Vue from 'vue';
import { FitDialog } from '@tencent/wphk-ui';
import store from './business/store';
import { hideDialog } from './business/main';

export default Vue.extend({
  components: { FitDialog },
  data() {
    return {
      dialog: store.dialog,
    };
  },
  methods: {
    handleClick(index) {
      if (typeof this.dialog.btns?.[index]?.click === 'function') {
        // @ts-ignore
        this.dialog.btns[index].click(hideDialog);
      } else {
        hideDialog();
      }
    },
  },
});
